import { z } from "zod";
import { LinkSchema } from "./common";

export const NavItemSchema = z.object({
  label: z.string().min(1).max(40),
  href: z.string().min(1).max(500),
  children: z.array(LinkSchema).max(12).optional(),
});

export const SocialSchema = z.object({
  network: z.enum(["x", "linkedin", "instagram", "youtube", "facebook", "whatsapp", "github"]),
  url: z.url(),
});

export const SiteSettingsSchema = z.object({
  site_name: z.string().min(1).max(80).default("AurumIQ"),
  tagline: z.string().max(160).default("Intelligent Gold Invoicing"),
  nav: z.array(NavItemSchema).max(10).default([]),
  header_cta: LinkSchema.optional(),
  footer: z
    .object({
      columns: z
        .array(
          z.object({
            heading: z.string().max(40),
            links: z.array(LinkSchema).max(12),
          }),
        )
        .max(5)
        .default([]),
      legal_links: z.array(LinkSchema).max(8).default([]),
      copyright: z.string().max(160).optional(),
    })
    .default({ columns: [], legal_links: [] }),
  socials: z.array(SocialSchema).max(8).default([]),
  seo: z
    .object({
      default_title: z.string().max(70).optional(),
      title_template: z.string().max(80).default("%s · AurumIQ"),
      default_description: z.string().max(200).optional(),
      default_og_image_id: z.string().max(64).optional(),
      twitter_handle: z.string().max(30).optional(),
    })
    .default({ title_template: "%s · AurumIQ" }),
  contact_email: z.email().optional(),
  whatsapp: z.string().max(30).optional(),
});
export type SiteSettings = z.infer<typeof SiteSettingsSchema>;
export type SiteSettingsInput = z.input<typeof SiteSettingsSchema>;
